import { render } from "./FormText.vue?vue&type=template&id=c689f3be&scoped=true"
import script from "./FormText.vue?vue&type=script&lang=js"
export * from "./FormText.vue?vue&type=script&lang=js"

import "./FormText.vue?vue&type=style&index=0&id=c689f3be&lang=scss&scoped=true"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c689f3be"]])

export default __exports__